module.exports = __webpack_public_path__ + "img/fastfood.2b42efd1.jpeg";